export default __webpack_public_path__ + "static/media/cubeSelected.aefb954d.png";